import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import Button from '@mui/material/Button';
import React, { useState } from 'react';

import { TopBarFeedbackButtonDialog } from '@/components/layout/topBar/components/feedbackButton/components/TopBarFeedbackButtonDialog.comp.tsx';
import { AnnouncementAnchor } from '@/contexts/announcements/AnnouncementAnchor.comp.tsx';
import { AnnouncementAnchorKey } from '@/contexts/announcements/announcements.definitions.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const TopBarFeedbackButton: React.FC = () => {
  const { t } = useTranslationWithPrefix('topBar.feedbackButton');
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  return (
    <>
      <AnnouncementAnchor
        anchorKey={AnnouncementAnchorKey.TOP_BAR_FEEDBACK}
        sx={{ display: 'inline-flex' }}
      >
        <Button endIcon={<CampaignOutlinedIcon />} onClick={handleOpenDialog} variant="outlined">
          {t('label')}
        </Button>
      </AnnouncementAnchor>
      {isDialogOpen && <TopBarFeedbackButtonDialog onClose={handleCloseDialog} />}
    </>
  );
};
